module.exports = __webpack_public_path__ + "img/tongdun.490fc462.png";